import React from "react";
import "./Onboarding.scss";

import { withAuthorization } from "components/Session";
import { withFirebase } from "components/Firebase";
import { compose } from "recompose";

import Input from "components/Input";
import Button from "components/Button";

const INITIAL_STATE = {
  userId: "",
  form: {
    userName: "",
    picture: "",
    firstName: "",
    lastName: "",
    location: "",
    description: "",
    workHistory: [],
    skills: [],
    links: []
  },
  status: {
    userNameError: false
  }
};

class Onboarding extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }
  handleInputChange = e => {
    console.log(e);
    const { form } = this.state;
    const { id, value } = e.target;

    form[id] = value;

    this.setState({ form });
  };

  handleUsernameBlur = e => {
    const { value } = e.target;
    const { status } = this.state;

    this.props.firebase
      .usernameAvailable(value, this.state.userId)
      .then(response => {
        status.userNameError = false;
        status.dirty = true;
        this.setState({ status });
      })
      .catch(error => {
        status.userNameError = true;
        status.dirty = false;
        this.setState({ status });
      });
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      firstName,
      lastName,
      location,
      userName,
      description,
      workHistory,
      links,
      skills
    } = this.state.form;
    const { userId } = this.state;

    this.props.firebase
      .user(userId)
      .update({
        firstName,
        lastName,
        location,
        userName,
        description,
        workHistory,
        links,
        skills
      })
      .then(() => {
        window.location.href = "create-project";
      })
      .catch(error => console.error(error));
  };
  componentDidMount() {
    const userId = this.props.firebase.auth.currentUser.uid;
    this.setState({ userId });
    this.props.firebase
      .user(userId)
      .get()
      .then(response => {
        if (response.exists) {
          const { firstName, lastName, picture } = response.data();
          const { form } = this.state;
          form.firstName = firstName;
          form.lastName = lastName;
          form.picture = picture;
          this.setState({ form });
        }
      })
      .catch(error => console.error(error));
  }
  render() {
    const { userName, firstName, lastName, location } = this.state.form;
    const { userNameError } = this.state.status;
    return (
      <div className="Onboarding">
        <div className="OnboardingForm">
          <div className="content">
            <h3>Get started</h3>
            <form onSubmit={this.handleSubmit} action="">
              <Input
                onBlur={this.handleUsernameBlur}
                onChange={this.handleInputChange}
                autoFocus
                required
                name="userName"
                label="Username"
                value={userName}
                type="text"
                placeholder=""
                error={
                  userNameError
                    ? "This username is taken, please select another"
                    : null
                }
              />
              <Input
                onChange={this.handleInputChange}
                required
                name="firstName"
                label="First name"
                value={firstName}
                type="text"
                placeholder="John"
              />
              <Input
                onChange={this.handleInputChange}
                required
                name="lastName"
                label="Last name"
                value={lastName}
                type="text"
                placeholder="Smith"
              />
              <Input
                onChange={this.handleInputChange}
                required
                name="location"
                label="Location"
                value={location}
                type="text"
                placeholder="Bellevue, WA"
              />
              <Button disabled={userNameError} type="primary">
                Create your first project
              </Button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const condition = authUser => !!authUser;

export default compose(
  withFirebase,
  withAuthorization(condition)
)(Onboarding);
